import { inject } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs';

import { ViewActions, ViewListActions } from '@core/views-data';

export const snapshotUpdateViewName = createEffect(
  (actions = inject(Actions)) =>
    actions.pipe(
      ofType(ViewActions.saveSnapshot),
      map(({ payload: { viewId, form } }) =>
        ViewListActions.partialUpdate({
          payload: { id: viewId, name: form.name, layout: form.layout, symbol: form.symbol },
        }),
      ),
    ),
  { functional: true },
);
